import {LogLevel} from "@microsoft/signalr";

export class NotificationMessage {
  memory: {mb: number, total: number};
  constructor(init?: Partial<NotificationMessage>) {
    Object.assign(this, init);
  }

  task: string;
  taskId: string;
  info: string;
  timestamp: Date;
  isCanceled: boolean;
  logLevel: LogLevel;
}
